"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgJemstone = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    fill: "rgba(255,255,255,0)",
    d: "M0 0h24v24H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Path 263",
    d: "M17.765 5.944l-5.349-3.568a.75.75 0 00-.832 0L6.235 5.944a.75.75 0 00-.334.624v10.864a.749.749 0 00.334.624l5.349 3.568a.75.75 0 00.832 0l5.349-3.568a.749.749 0 00.334-.624V6.568a.75.75 0 00-.334-.624zM11.25 8.607l-3.666-1.76 3.666-2.445zm0 1.663v2.53l-3.849 2.567V8.423zm0 4.333v4.995l-3.745-2.5zm1.5 0l3.744 2.5-3.744 2.5zm0-1.8v-2.53l3.849-1.847v6.944zm0-4.193V4.405l3.666 2.445z"
  }, void 0)]
}), void 0);

exports.default = SvgJemstone;